// ---------------------------------------------------------------------------
// Notifications module — i18n messages (de-AT)
// ---------------------------------------------------------------------------

import i18n from '@/i18n';

export const notificationsLocales = {
  'de-AT': {
    notifications: {
      bell: {
        label: 'Benachrichtigungen',
        open: 'Benachrichtigungen öffnen',
        empty: 'Keine Benachrichtigungen.',
        mark_all_read: 'Alle als gelesen markieren',
        show_all: 'Alle Nachrichten',
        loading: 'Wird geladen …',
        unread_badge_aria: '{count} ungelesene Benachrichtigungen',
      },
      list: {
        title: 'Benachrichtigungen',
        subtitle: 'Alle Benachrichtigungen aus dem System.',
        filters: {
          unread_only: 'Nur ungelesene',
        },
        empty: 'Du hast noch keine Benachrichtigungen.',
        mark_read: 'Als gelesen markieren',
        read_at: 'Gelesen am {date}',
        created_at: 'Empfangen am {date}',
      },
      toast: {
        marked_read: 'Als gelesen markiert.',
        mark_read_failed: 'Konnte nicht als gelesen markiert werden.',
      },
    },
  },
  en: {
    notifications: {
      bell: {
        label: 'Notifications',
        open: 'Open notifications',
        empty: 'No notifications.',
        mark_all_read: 'Mark all as read',
        show_all: 'All notifications',
        loading: 'Loading …',
        unread_badge_aria: '{count} unread notifications',
      },
      list: {
        title: 'Notifications',
        subtitle: 'All notifications from the system.',
        filters: {
          unread_only: 'Unread only',
        },
        empty: 'You have no notifications yet.',
        mark_read: 'Mark as read',
        read_at: 'Read on {date}',
        created_at: 'Received on {date}',
      },
      toast: {
        marked_read: 'Marked as read.',
        mark_read_failed: 'Could not mark as read.',
      },
    },
  },
} as const;

// Merge into the global i18n instance on import. This is a no-op in the
// vitest environment (which instantiates its own i18n in test-setup.ts).
for (const [locale, messages] of Object.entries(notificationsLocales)) {
  i18n.global.mergeLocaleMessage(locale, messages);
}
